import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import {cartActions, flexActions, footerActions, fixActions, productActions, stockDateActions} from "./actions";
import {cartMutations, flexMutations, footerMutations, fixMutations, productMutations, passesMutations, stockDateMutations} from "./mutations";
import {passescartGetters, cartGetters, flexGetters, fixGetters, productGetters, stockDateGetters} from "./getters";

Vue.use(Vuex);

const myPlugin = store => {
    store.subscribe((mutation, state) => {
        const {type, payload} = mutation;

        if (process.env.NODE_ENV === 'production') return;

        console.groupCollapsed(`${mutation.type}`);
        console.groupCollapsed(`Mutation`);
        // console.log(`Type`, type);
        // console.log(`Payload`, payload);
        console.groupEnd();
        console.groupCollapsed(`State`);
        console.log(state);
        console.groupEnd();
        console.groupEnd();
    });
};

export default new Vuex.Store({
    strict: true,
    state: {
        products: [],
        flexTickets: [],
        fixTickets: [],
        todayProducts: [],
        promotionsProducts: [],
        cart: [],
        passescart: [],
        loading: false,
        ticketHeights: [],
        ticket: {},
        show: false,
        weekdaysOnly: true,
        daysQuantity: 1,
        events: {},
        selectedFixEvent: {},
        startDate: moment().add(1, 'day'),
        fixTicketDefaultDate: moment().add(1, 'day'),
        endDate: moment('2023-10-06', 'YYYY-MM-DD'),
        stockDate: [],
    },
    actions: Object.assign({}, productActions, cartActions, footerActions, flexActions, fixActions, stockDateActions),
    mutations: Object.assign({}, productMutations, cartMutations, footerMutations, flexMutations, fixMutations, passesMutations, stockDateMutations),
    getters: Object.assign({}, productGetters, cartGetters, passescartGetters, flexGetters, fixGetters, stockDateGetters),
    plugins: [myPlugin]
});




// WEBPACK FOOTER //
// ./src/store/index.js